export default "__VITE_ASSET__faf89a52__"